import React from 'react';
import {
	Box,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
} from '@mui/material';
import { Link } from 'react-router-dom';

export default function TableData(props) {
	const users = props.usersArray;
	const tableData = () => {
		return (
			<Box className='table_responsive'>
				<TableContainer className='tbl_mn br-24 br-btm-0 '>
					<Table className='table-design'>
						<TableHead>
							<TableRow className='tbl_rw'>
								<TableCell className='fz-18 fw-bold'>Name</TableCell>
								<TableCell className='fz-18 fw-bold'>Email</TableCell>
								<TableCell className='fz-18 fw-bold'>DOB</TableCell>
								<TableCell className='fz-18 fw-bold'>Address</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{users && users?.map((item, i) => {
								return(
									<TableRow key={i}>
									<TableCell className='fz-16' scope='row'>
										{item.first_name+ " "  + item.last_name}
									</TableCell>
									<TableCell className='fz-16'>{item.email}</TableCell>
									<TableCell className='fz-16'>{item.dob}</TableCell>
									<TableCell className='fz-16'>
										{item.address}
									</TableCell>
								</TableRow>
								)
							})}
						</TableBody>
					</Table>
				</TableContainer>
			</Box>
		);
	};

	return (
		<Box height='100%' display='flex' className='box-wrapper br-24' flexDirection='column' justifyContent='start'>
			<div className='heading-btn_wrapper'>
				<h5 className='fz-20 fw-bold'>Recent Users</h5>
				<Link to='/users' className='learn-btn '>
					View More
				</Link>
			</div>
			{tableData()}
		</Box>
	);
}
